import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { StyleSheet, css } from 'aphrodite';
import Modal from 'react-modal';
import { Theme } from '../../config/theme';
import { updateAppState } from '../../actions/applicationState';
import { reportMember, getCurrentMember, updateUser } from '../../actions/user';
import { mapStateToProps, mapDispatchToProps } from '../../utils';

import TextField from '../TextField';
import Button from '../Button';

const CLOSE_ICON = require('./close.svg');

class ReportModal extends Component {
  constructor(props) {
    super(props);
    this.openHandler = this.props.openHandler.bind(this);
    this.reportMemberProfile = this.reportMember.bind(this);
    this.setValue = this.updateTextField.bind(this);
    this.state = {
      report_submitted: false,
      errors: {
        report_message: false,
      },
    };
  }

  reportMember() {
    // Initiate loading sequence
    this.props.dispatch(updateAppState({
      loading: true,
    })).then(() => {
      // Continue loading during request
      this.props.dispatch(updateAppState({
        loading: true,
      }));
      // Dispatching member report request
      this.props.dispatch(
        reportMember({
          reporter_id: this.props.user.id,
          reporter_name: this.props.user.first_name + ' ' + this.props.user.last_name,
          reported_id: this.props.match.params.id,
          email: this.props.user.email,
          message: this.state.report_message,
        }, this.props.user.access_token),
      ).then(() => {
        // discontinue dog sharing
        // Manage state with response
        this.setState({
          report_submitted: true,
        });
        this.props.dispatch(getCurrentMember(this.props.user.id, this.props.user.access_token))
          .then((response) => {
            this.props.dispatch(updateUser(response));

            this.props.dispatch(updateAppState({
              loading: false,
            }));
          });
      }, () => {
        this.props.dispatch(updateAppState({
          loading: false,
        }));
      });
    });
  }

  updateTextField(key, value) {
    const updatedState = {
      [key]: value,
    };

    this.setState(updatedState);

    setTimeout(() => {
      this.validateForm();
      if (this.state.errors[key]) {
        this.validateForm();
      }
    }, 10);
  }

  validateForm() {
    const errors = {};

    if (!this.state.report_message.length) {
      errors.report_message = 'You need to provide a reason on why you are reporting this member';
    } else {
      errors.report_message = false;
    }

    let formErrors = false;

    for (const key in errors) { //eslint-disable-line
      if (errors[key] !== null) {
        formErrors = true;
      }
    }

    if (formErrors) {
      this.setState({
        errors,
      });

      return false;
    }

    return true;
  }

  render() {
    return (
      <Modal
        isOpen={this.props.open}
        className={css(styles.container)}
        style={{
          overlay: {
            backgroundColor: 'rgba(0,0,0,0.67)',
            zIndex: 10,
            display: 'flex',
          },
        }}
        contentLabel="Report"
      >
        <div className={css(styles.modal_wrapper)}>
          <div className={css(styles.header)}>
            <h2 className={css(styles.title)}>
              {
                this.state.report_submitted === true ?
                  (<span> Report submitted</span>) : (<span> Report this member</span>)
              }
            </h2>
            <div
              className={css(styles.close_icon)}
              onClick={this.props.openHandler}
              role="button"
              tabIndex={0}
            >
              <img src={CLOSE_ICON} alt="Close modal" />
            </div>
          </div>
          {
            this.state.report_submitted === true ? (
              <div className={css(styles.body)}>
                <p className={css(styles.successParagraph)}>
                  Thank you for your feedback. We will review this report and take any
                  action necessary to ensure the safety of our community.
                </p>

                <Button
                  title="Continue"
                  theme="blue"
                  handler={this.openHandler}
                  styles={styles.full_width_button} />
              </div>
            ) : (
              <div className={css(styles.body)}>
                <div className={css(styles.comments)}>
                  <TextField
                    textArea
                    name="report_message"
                    styles={styles.textArea}
                    handler={this.setValue}
                    placeholder="Tell us why you’d like to report this user…"
                    error={this.state.errors.report_message}
                  />
                </div>

                {
                  this.state.errors.report_message ? (
                    <Button
                      title="Submit Report"
                      theme="disabled"
                      disabled={true} //eslint-disable-line
                      styles={styles.full_width_button} />
                  ) : false
                }
                {
                  !this.state.errors.report_message ? (
                    <Button
                      title="Submit Report"
                      theme="blue"
                      handler={this.reportMemberProfile}
                      styles={styles.full_width_button} />
                  ) : false
                }
              </div>
            )
          }
        </div>
      </Modal>
    );
  }
}

ReportModal.propTypes = {
  open: PropTypes.bool,
  openHandler: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

ReportModal.defaultProps = {
  open: false,
};

const openModalKeyFrames = {
  from: {
    transform: 'scale(0.8)',
    animationTimingFunction: 'ease-in',
  },

  to: {
    transform: 'scale(1)',
    animationTimingFunction: 'ease-in',
  },
};

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: 590,
    maxWidth: '100vw',
    height: 513,
    maxHeight: '100vh',
    backgroundColor: Theme.white,
    borderRadius: 5,
    overflow: 'hidden',
    outline: 'none',
    margin: 'auto auto',
    animationName: openModalKeyFrames,
    animationDuration: '100ms',
    animationDirection: 'alternate',
  },
  modal_wrapper: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    height: 600 - 100,
    width: '100%',
    boxSizing: 'border-box',
    padding: '0px 80px',
  },
  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '50px 0px 35px',
  },
  title: {
    marginBottom: 0,
    fontFamily: Theme.font_family_heading,
    fontSize: 30,
    fontWeight: '900',
  },
  close_icon: {
    position: 'absolute',
    right: 15,
    top: 15,
    outline: 'none',
    cursor: 'pointer',
    transition: 'opacity 180ms ease-in-out',
    ':hover': {
      opacity: 0.6,
    },
  },
  body: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    textAlign: 'center',
  },
  stars: {
    display: 'flex',
    marginBottom: 40,
  },
  star: {
    display: 'block',
    height: 30,
    width: 30,
    margin: '0 8px',
    stroke: '#DFDFDF',
    fill: '#F4F4F4',
    transition: 'all 300ms',
    cursor: 'pointer',
    outline: 'none',
  },
  star_active: {
    stroke: '#39b4d6',
    fill: '#39b4d6',
  },
  successParagraph: {
    marginBottom: 60,
    fontFamily: Theme.font_family_primary,
    fontSize: 16,
    lineHeight: 1.5,
    color: '#828282',
  },
  textArea: {
    display: 'flex',
    flexDirection: 'column',
    height: 200,
    width: 340,
    marginBottom: 25,

    ':not(.a) > *': {
      flexGrow: 1,
    },
  },
  paragraph: {
    marginBottom: 20,
    fontFamily: Theme.font_family_primary,
    fontSize: 14,
    color: '#828282',
  },
  actions_container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  sign_up_container: {
    fontFamily: Theme.font_family_primary,
    fontSize: 16,
  },
  sign_up_link: {
    display: 'inline',
    fontFamily: Theme.font_family_secondary,
    letterSpacing: 1,
    marginLeft: 5,
    textTransform: 'uppercase',
    fontWeight: 'bold',
  },
  forgotten_password: {
    flex: 1,
    fontFamily: Theme.font_family_primary,
    fontSize: 14,
  },
  login_button_container: {
    flex: 1,
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportModal);



// WEBPACK FOOTER //
// ./src/components/ReportModal/index.js